<h1 class="title">
  @if (type) {
    <rkt-icon [name]="type"></rkt-icon>
  }
  {{ name }}
</h1>

<button class="close-button" (click)="activeModal.close()"><rkt-icon name="times"></rkt-icon></button>

@if (fileFormat !== 'PDF') {
  <div class="image-preview">
    @if (loading()) {
      <p class="preview-message">Loading preview…</p>
    } @else if (imageFailed()) {
      <p class="preview-message">This image can't be shown in your browser. Use Download to save and open it.</p>
    } @else if (displayUrl()) {
      <img [src]="displayUrl()" [alt]="name" (error)="onImageError()" />
    }
  </div>
}

@if (fileFormat === 'PDF') {
  <ngx-extended-pdf-viewer
    [src]="url"
    [showBorders]="false"
    [showToolbar]="false"
    [textLayer]="false"
    [sidebarVisible]="false"
    backgroundColor="#F7F7F7"
    [authorization]="true"
  ></ngx-extended-pdf-viewer>
}
